// 性别
export enum Gender {
  male = 1,
  female = 2,
};

// 客户来源
export enum AddWay {
  unknown = 0,
  qrCode = 1,
  searchMobile = 2,
  businessCard = 3,
  groupChat = 4,
  mobileContact = 5,
  wechatContact = 6,
  wechatFriendApply = 7,
  thirdAppCustomerService = 8,
  searchMail = 9,
  innerShare = 201,
  assign = 202,
};

// 客户类型
export enum CustomerType {
  wechat = 1,
  workWecaht = 2,
};

// 客户好友状态
export enum CustomerStatus {
  add = 0, // 好友
  deleted = 1,  // 已删除
  resign = 2,  // 添加人已离职
}

export enum VisibilityScope {
  private = 'VISIBILITY_SCOPE_PRIVATE',
  public = 'VISIBILITY_SCOPE_PUBLIC',
}

// 阶段
export enum ProgressStatus {
  unknown = 'PROGRESS_STATUS_UNKNOWN',
  lead = 'PROGRESS_STATUS_LEAD',
  potential = 'PROGRESS_STATUS_POTENTIAL',
  order = 'PROGRESS_STATUS_ORDER',
};

// 线索阶段状态
export enum CleaningStatus {
  unknown = 'CLEANING_STATUS_UNKNOWN',
  pending = 'CLEANING_STATUS_PENDING',
  valid = 'CLEANING_STATUS_VALID',
  invalid = 'CLEANING_STATUS_INVALID',
  tempNotValid = 'CLEANING_STATUS_TEMPNOTVALID',
  continuable = 'CLEANING_STATUS_CONTINUABLE',
};

// 商机阶段状态
export type TransactionProbability = 0 | 20 | 40 | 60 | 80;

// 订单阶段状态
export enum OrderStatus {
  submitted = 'ORDER_STATUS_SUBMITTED',
  paid = 'ORDER_STATUS_PAID',
  unpaid = 'ORDER_STATUS_UNPAID',
  review = 'ORDER_STATUS_REVIEW',
  online = 'ORDER_STATUS_ONLINE',
  notOnline = 'ORDER_STATUS_NOT_ONLINE',
};

// 标签
interface Tag {
  id: string;
  name: string;
};

// 标签组
export interface TagGroup {
  groupId: string;
  groupName: string;
  tag: Array<Tag>;
}

// 线索联系人
export interface LeadContact {
  leadId: number;
  contactId: number;
  contactName: string;
  companyName: string;
  leadFollowName: string;
  progressStatus: ProgressStatus;
  visibilityScope: VisibilityScope;
  permissions: Array<number>;
  viewable: boolean;
};

// 企微客户
export interface Customer {
  onlineSalesCustomerId: number;
  relationId: number;
  employeeId: number; // 添加人
  employeeName: string;
  userId: string;
  agencyId: number;
  corpId: string;
  description: string;
  createdByUserId: number;
  addWay: AddWay;
  status: CustomerStatus;
  addTime: string;
  tagIdList: Array<string>;
  tagNames: Array<string>;
  onlineSalesCustomer: {
    agencyId: number;
    name: string;
    type: CustomerType;
    gender: Gender;
    unionId: string;
    corpName: string;
    corpFullName: string;
    externalUserId: string;
    onlineSalesCustomerId: number;
  };
  leads: Array<LeadContact>;
};

// 电话
interface Phone {
  value: string;
  values: Array<string>;
}

export interface Contact {
  contactId: number;
  contactName: string;
  title: string;
  mobile: Phone;
  telephone: Phone;
  qqNumber: string;
  weChat: string;
};

// 线索
export interface Lead {
  leadId: number;
  company: {
    companyName: string;
  };
  contactInfos: Array<Contact>;
  progressStatus: string; // 阶段
  cleaningStatus: string; // 线索阶段状态
  leadFollowName: string; // 线索跟进人
  potential: {
    leadFollowName: string; // 商机跟进人
    transactionProbability: number; // 商机阶段状态
  };
  order: {
    orderStatus: string; // 订单状态
    followOperatorList: Array<string>; // 运营人员
  };
};

export interface GetCustomerList {
  addTimeBegin?: string;
  addTimeEnd?: string;
  tagIds?: Array<string>;
  addEmployeeId?: number;
  saleEmployeeId?: number;
  hasRelatedLead?: boolean | 1 | 0;
  name?: string;
  pageIndex: number;
  pageSize: number;
  page?: number;
  page_size?: number;
};

export interface GetLeadList {
  leadId?: number;
  contactName?: string;
  mobile?: string;
  companyName?: string;
  visibilityScope: VisibilityScope;
  pageIndex: number;
  pageSize: number;
  page?: number;
  page_size?: number;
}

export interface UnbindLeadContact {
  leadId: number;
  contactId: number;
};

export interface BindLeadContact {
  relationId: number;
  contact: Array<{
    leadId: number;
    contactId: number;
  }>
};
